// @ts-ignore
/* eslint-disable */
import request from "src/lib/axios";

/** 获取平台结构化系统设置 GET /api/v1/hq/platform-setting */
export async function HqPlatformSettingControllerGetV1(options?: {
  [key: string]: any;
}) {
  return request<MyApi.ApiResponseOutputPlatformSettingDto>(
    "/api/v1/hq/platform-setting",
    {
      method: "GET",
      ...(options || {}),
    }
  );
}

/** 更新平台结构化系统设置 PUT /api/v1/hq/platform-setting */
export async function HqPlatformSettingControllerUpdateV1(
  body: MyApi.UpdatePlatformSettingDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputPlatformSettingDto>(
    "/api/v1/hq/platform-setting",
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}
